/* eslint-disable  react/display-name */
import { Grid, IconButton, Tooltip, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import PConfirm from "../../../components/pos/PConfirm";
import PDatePicker from "../../../components/pos/PDatePicker";
import PDialog from "../../../components/pos/PDialog";
import PSelect from "../../../components/pos/PSelect";
import PText from "../../../components/pos/PText";
import PCheck from "../../../components/pos/PCheck";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { Store } from "../../../utils/Store";
import { SyncUtils } from "../../../utils/SyncUtils";
import GenericReportViewer from "./../../reports/GenericReportViewer";
import PRSelect from "../../../components/pos/PRSelect";
import { StringUtils } from "../../../utils/StringUtils";

export default function MultipleTransactionsCrud(props) {
  const { t } = useTranslation();
  const translate = t;

  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState("New Transactions");
  const [confirmContext, setConfirmContext] = useState({
    open: false,
  });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);

  const [voucherNumber, setVoucherNumber] = useState("AUTO");
  const [voucherNumberError, setVoucherNumberError] = useState("");
  const [fromLedger, setFromledger] = useState("");
  const [fromLedgerError, setFromledgerError] = useState("");

  const [toLedger, setToledger] = useState("");
  const [toLedgerError, setToledgerError] = useState("");

  const [amount, setAmount] = useState("");
  const [amountError, setAmountError] = useState("");
  const [payerName, setPayerName] = useState("");
  const [payerNameError, setPayerNameError] = useState("");
  const [payeeName, setPayeeName] = useState("");
  const [payeeNameError, setPayeeNameError] = useState("");
  const [status, setStatus] = useState("");
  const [statusError, setStatusError] = useState("");
  const [statusOptions, setStatusOptions] = useState([]);
  const [referenceNumber, setReferencenumber] = useState("");
  const [referenceNumberError, setReferencenumberError] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [transactionDate, setTransactiondate] = useState("");
  const [transactionDateError, setTransactiondateError] = useState("");
  const [transactionMode, setTransactionMode] = useState("");
  const [type, setType] = useState("");
  const [optionsLedger, setOptionsLedger] = useState([]);
  const [fromLedgerOptions, setFromLedgerOptions] = useState([]);
  const [toLedgerOptions, setToLedgerOptions] = useState([]);
  const [fromLedgerBalance, setFromLedgerBalance] = useState(0);
  const [toLedgerBalance, setToLedgerBalance] = useState(0);
  const [fromLedgerNature, setFromLedgerNature] = useState("");
  const [toLedgerNature, setToLedgerNature] = useState("");
  const [toAccountItemsList, setToAccountItemsList] = useState([]);
  const [taxable, setTaxable] = useState(false);
  const [showTaxableOption, setShowTaxableOption] = useState(false);

  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.multiItemTransactionCrud = {
    showTransactionsCrudWindow: showTransactionsCrudWindow,
  };

  useEffect(() => {
    setStatusOptions([
      { name: "Completed", value: "Completed" },
      { name: "Pending", value: "Pending" },
    ]);
  }, []);

  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  async function getAllLedgers(mode) {
    setOptionsLedger([]);
    let ledgers = await API.get("/api/v1/ledgerlist");
    getCashBankAccounts(mode, ledgers.data);
    getGeneralLedgers(ledgers.data);
  }

  function getGeneralLedgers(ledgers) {
    let generalLedgers = ledgers.filter(
      (element) =>
        element.type != "VENDOR" &&
        element.type != "CUSTOMER" &&
        !element.code.startsWith("010103") &&
        !element.code.startsWith("010102")
    );
    if (props.type === "Receipt")
      setFromLedgerOptions(populateFromLedgerOptions(generalLedgers));
    else if (props.type === "Payment")
      setToLedgerOptions(populateToLedgerOptions(generalLedgers));
    else {
      setFromLedgerOptions(populateFromLedgerOptions(generalLedgers));
      setToLedgerOptions(populateToLedgerOptions(generalLedgers));
    }
  }

  function getCashBankAccounts(mode, ledgers) {
    let cashBankLedgers = [];
    if (mode === "Cash") {
      cashBankLedgers = ledgers.filter((element) =>
        element.code.startsWith("010103")
      );
    } else {
      cashBankLedgers = ledgers.filter((element) =>
        element.code.startsWith("010102")
      );
    }

    if (props.type === "Payment")
      setFromLedgerOptions(populateFromLedgerOptions(cashBankLedgers));
    else if (props.type === "Receipt")
      setToLedgerOptions(populateToLedgerOptions(cashBankLedgers));
  }

  function populateFromLedgerOptions(data) {
    const dataArray = [];
    data.map((item, key) =>
      dataArray.push({
        id: item.id,
        name: item.name,
        value: item,
        label: item.name,
      })
    );
    return dataArray;
  }

  function populateToLedgerOptions(data) {
    const dataArray = [];
    data.map((item, key) =>
      dataArray.push({
        id: item.id,
        name: item.name,
        value: item,
        label: item.name,
      })
    );
    return dataArray;
  }

  function showTransactionsCrudWindow(transMode) {
    if (props.type === "Payment") {
      setShowTaxableOption(true);
    }
    getAllLedgers(transMode);
    setVoucherNumber("AUTO");
    setTransactionMode(transMode);
    setType(props.type);
    setWindowTitile("New " + transMode + " " + props.type);
    resetFields();
    setMode("create");
    setLiveValidation(false);
    setOpenWindow(true);
  }

  function populateData(bean) {
    setVoucherNumber(bean.voucherNumber);
    setFromledger(
      bean.fromLedger
        ? {
            id: bean.fromLedger.id,
            name: bean.fromLedger.name,
            value: bean.fromLedger,
          }
        : null
    );

    setToledger(
      bean.toLedger
        ? {
            id: bean.toLedger.id,
            name: bean.toLedger.name,
            value: bean.toLedger,
          }
        : null
    );
    setFromLedgerBalance(bean.fromLedger.balance);
    setToLedgerBalance(bean.toLedger.balance);
    setAmount(bean.amount);
    setPayeeName(bean.payeeName);
    setPayerName(bean.payerName);
    setStatus(bean.status ? { id: bean.status, name: bean.status } : null);
    setType(bean.type);
    setTransactionMode(bean.transactionMode);
    setReferencenumber(bean.referenceNumber);
    setDescription(bean.description);
    setTransactiondate(bean.transactionDate);
    setTaxable(bean.taxable);
    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setFromledger("");
    setFromledgerError("");
    setToledger("");
    setToledgerError("");
    setAmount("");
    setAmountError("");
    setPayerNameError("");

    setPayeeNameError("");
    setStatus("");
    setStatusError("");
    setReferencenumber("");
    setReferencenumberError("");
    setDescription("");
    setDescriptionError("");
    setTransactiondate("");
    setTransactiondateError("");
    setFromLedgerBalance(0);
    setToLedgerBalance(0);
    setFromLedgerNature("");
    setToLedgerNature("");
    let token = localStorage.getItem("w_accessToken");
    let jwt = Store.parseJwt(token);
    if (props.type == "Payment") {
      setPayerName(jwt.sub);
      setPayeeName("");
    } else if (props.type == "Receipt") {
      setPayerName("");
      setPayeeName(jwt.sub);
    } else {
      setPayerName("");
      setPayeeName("");
    }
    setToAccountItemsList([]);
    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onDelete() {}
  var biRef = {};

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        for (let item of payload) {
          let result = await API.post("/api/v1/accountingtransaction", item);
          SyncUtils.requestSync(result.headers);
        }
        props.onRefresh();
        setOpenWindow(false);
        props.showMessage("success", "Saved Successfully");
      } catch (err) {
        console.log("ERROR", err);
        props.showMessage("error", "Not able to Save Transactions");
      }
    }
  }

  function createPayload() {
    let payloadList = [];
    for (let i = 0; i < toAccountItemsList.length; i++) {
      let saveObject = Object.create(null);
      saveObject["voucherNumber"] = voucherNumber;
      if (props.type === "Receipt") {
        saveObject["fromLedger"] = toAccountItemsList[i].accountLedger.value;
        saveObject["toLedger"] = fromLedger.value;
        saveObject["fromLedgerName"] = toAccountItemsList[i].accountLedger.name;
        saveObject["toLedgerName"] = fromLedger.name;
      } else if (props.type === "Payment") {
        saveObject["taxable"] = toAccountItemsList[i].taxable;
        saveObject["fromLedger"] = fromLedger.value;
        saveObject["toLedger"] = toAccountItemsList[i].accountLedger.value;
        saveObject["fromLedgerName"] = fromLedger.name;
        saveObject["toLedgerName"] = toAccountItemsList[i].accountLedger.name;
      }
      saveObject["payerName"] = payerName;
      saveObject["payeeName"] = payeeName;
      saveObject["status"] = status ? status.value : "";
      saveObject["referenceNumber"] = referenceNumber;
      saveObject["description"] = description;
      saveObject["transactionDate"] = StringUtils.getIsoDate(transactionDate);
      saveObject["type"] = type;
      saveObject["transactionMode"] = transactionMode;
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;

      saveObject["amount"] = toAccountItemsList[i].transactionAmount;
      payloadList.push(saveObject);
    }
    return payloadList;
  }

  function validate() {
    let flag = true;
    if (!voucherNumber || voucherNumber === "") {
      setVoucherNumberError("Vouchernumber is Required");
      flag = false;
    }
    if (!payerName || payerName === "") {
      setPayerNameError("Payer name is Required");
      flag = false;
    }
    if (!payeeName || payeeName === "") {
      setPayeeNameError("Payee name is Required");
      flag = false;
    }
    if (transactionMode === "Bank") {
      if (!status || status === "") {
        setStatusError("Status is Required");
        flag = false;
      }
    }
    if (!transactionDate || transactionDate === "") {
      setTransactiondateError("Transaction date is Required");
      flag = false;
    }

    if (!toAccountItemsList.length > 0) {
      props.showMessage("error", "Please add ledger entry before proceed!");
      return false;
    }
    for (let i = 0; i < toAccountItemsList.length; i++) {
      if (toAccountItemsList[i].accountLedger == null) {
        props.showMessage("error", "Ledger not selected at row: " + (i + 1));
        return false;
      }
      if (
        toAccountItemsList[i].transactionAmount == null ||
        toAccountItemsList[i].transactionAmount == ""
      ) {
        props.showMessage(
          "error",
          "Transaction amount is empty at row: " + (i + 1)
        );
        return false;
      }
    }
    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  function handleAmountChange(changedvalue) {
    let frombal = fromLedger.value.balance;
    let tobal = toLedger.value.balance;
    if (
      fromLedgerNature === "DEBIT" ||
      fromLedgerNature === "" ||
      fromLedgerNature === null
    ) {
      if (mode === "create") {
        frombal = Number(frombal) - Number(changedvalue);
      } else if (mode === "edit") {
        frombal =
          Number(frombal) + Number(origObject.amount) - Number(changedvalue);
      }

      if (Number(frombal) < 0) {
        setFromLedgerNature("CREDIT");
        frombal = Number(frombal) * -1;
        setFromLedgerBalance(frombal);
      } else if (Number(frombal) == 0) setFromLedgerNature("");
    } else if (fromLedgerNature == "CREDIT")
      setFromLedgerBalance(
        mode === "edit"
          ? Number(frombal) - Number(origObject.amount) + Number(changedvalue)
          : Number(frombal) + Number(changedvalue)
      );

    if (
      toLedgerNature === "CREDIT" ||
      toLedgerNature === "" ||
      toLedgerNature == null
    ) {
      if (mode === "create") {
        tobal = Number(tobal) - Number(changedvalue);
      } else if (mode === "edit") {
        frombal =
          Number(tobal) + Number(origObject.amount) - Number(changedvalue);
      }
      if (Number(tobal) < 0) {
        setToLedgerNature("DEBIT");
        tobal = Number(tobal) * -1;
        setToLedgerBalance(tobal);
      } else if (Number(tobal) == 0) setToLedgerNature("");
    } else if (toLedgerNature == "DEBIT")
      setToLedgerBalance(
        mode === "edit"
          ? Number(tobal) - Number(origObject.amount) + Number(changedvalue)
          : Number(tobal) + Number(changedvalue)
      );
  }

  function handleAddNewRowClick() {
    let toAccountItemsListTemp = [...toAccountItemsList];
    toAccountItemsListTemp.push({
      serialNumber: toAccountItemsListTemp.length + 1,
      accountLedger: null,
      transactionAmount: "",
      taxable: false,
    });
    setToAccountItemsList(toAccountItemsListTemp);
  }

  function onRemoveItemClicked(tableMeta, updateValue, value) {
    let toAccountItemsListTemp = [...toAccountItemsList];
    let updatedList = [];
    let index = 0;
    for (let i = 0; i < toAccountItemsListTemp.length; i++) {
      if (tableMeta.rowIndex != i) {
        toAccountItemsListTemp[i].serialNumber = index + 1;
        updatedList.push(toAccountItemsListTemp[i]);
        index++;
      }
    }
    setToAccountItemsList(updatedList);
    let totalAmount = 0;
    updatedList.map((item) => {
      if (item.transactionAmount && !item.transactionAmount == "") {
        totalAmount += parseFloat(item.transactionAmount);
      }
    });
    setAmount(totalAmount);
  }

  function findParent(code) {
    let parentCode = code.substring(0, 2);
    let parent = "";
    switch (parentCode) {
      case "01":
        parent = "Assets";
        break;
      case "02":
        parent = "Liability";
        break;
      case "03":
        parent = "Expense";
        break;
      case "04":
        parent = "Income";
        break;
      default:
        parent = "";
        break;
    }
    return parent;
  }

  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={8}>
            {option.value.name}
          </Grid>
          <Grid item xs={4} style={{ textAlign: "right", fontSize: 12 }}>
            {findParent(option.value.code)}
          </Grid>
        </Grid>
      );
    }
    if (!option.value) return "";
    return option.value.name;
  };

  const options = {
    filterType: null,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    pagination: false,
    selectableRows: "false",
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: 300,
  };
  const columns = [
    {
      name: "serialNumber",
      label: translate("SN"),
      options: {
        filter: false,
        sort: false,
        display: "true",
      },
    },
    {
      name: "accountLedger",
      label:
        props.type === "Receipt"
          ? translate("From Account")
          : translate("To Account"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 450 }}>
            <PRSelect
              options={
                props.type === "Receipt" ? fromLedgerOptions : toLedgerOptions
              }
              value={value}
              errorMessage={fromLedgerError}
              formatOptionLabel={formatOptionLabel}
              components={{ formatOptionLabel }}
              onChange={(newValue) => {
                let tempData = [...tableMeta.tableData];
                tempData[tableMeta.rowIndex].accountLedger = newValue;
                setToAccountItemsList(tempData);
              }}
            ></PRSelect>
          </div>
        ),
      },
    },

    {
      name: "transactionAmount",
      label: translate("Amount"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 145 }}>
            <PText
              value={value}
              type="number"
              onChange={(e) => {
                let tempData = [...tableMeta.tableData];
                tempData[tableMeta.rowIndex].transactionAmount = e.target.value;
                setToAccountItemsList(tempData);

                let totalAmount = 0;
                tempData.map((item) => {
                  if (item.transactionAmount && !item.transactionAmount == "") {
                    totalAmount += parseFloat(item.transactionAmount);
                  }
                });
                setAmount(totalAmount);
                //handleAmountChange(totalAmount);
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "taxable",
      label: "Taxable",
      options: {
        filter: false,
        sort: false,
        display: showTaxableOption,
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <PCheck
              onChange={(value) => {
                let tempData = [...tableMeta.tableData];
                tempData[tableMeta.rowIndex].taxable = value;
                setToAccountItemsList(tempData);
              }}
              checked={value}
              label={translate("Taxable")}
            ></PCheck>
          </div>
        ),
      },
    },
    {
      name: "action",
      label: translate("Action"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customHeadLabelRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <table width="100%">
                <tr>
                  <td align="right">Action</td>
                  <td align="right">
                    <Tooltip title={"Add new row"}>
                      <IconButton
                        color="secondary"
                        onClick={handleAddNewRowClick}
                      >
                        <AddIcon />
                      </IconButton>
                    </Tooltip>
                  </td>
                </tr>
              </table>
            </div>
          );
        },
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <Button
              onClick={() => onRemoveItemClicked(tableMeta, updateValue, value)}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "right",
              }}
            >
              {translate("REMOVE")}
            </Button>
          </div>
        ),
      },
    },
  ];

  const content = (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <table width="100%">
            <tr>
              <td>{translate("Voucher Number")}</td>
              <td>
                <PText
                  value={voucherNumber}
                  error={voucherNumberError}
                  onChange={(e) => setVoucherNumber(e.target.value)}
                  InputProps={{ readOnly: true }}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                {props.type === "Receipt"
                  ? translate("To Account")
                  : translate("From Account")}
              </td>
              <td>
                <PRSelect
                  options={
                    props.type === "Receipt"
                      ? toLedgerOptions
                      : fromLedgerOptions
                  }
                  value={fromLedger}
                  formatOptionLabel={formatOptionLabel}
                  components={{ formatOptionLabel }}
                  onChange={(newValue) => {
                    setFromledger(newValue);
                    setFromLedgerBalance(newValue.value.balance);
                    setFromLedgerNature(newValue.value.nature);
                  }}
                ></PRSelect>
              </td>
            </tr>
            <tr>
              <td>{translate("Payer")}</td>
              <td>
                <PText
                  value={payerName}
                  error={payerNameError}
                  onChange={(e) => setPayerName(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>{translate("Reference Number")}</td>
              <td>
                <PText
                  value={referenceNumber}
                  error={referenceNumberError}
                  onChange={(e) => setReferencenumber(e.target.value)}
                ></PText>
              </td>
            </tr>
            {transactionMode === "Bank" && (
              <tr>
                <td>{translate("Status")}</td>
                <td>
                  <PSelect
                    options={statusOptions}
                    value={status}
                    errorMessage={statusError}
                    onChange={(event, newValue) => {
                      setStatus(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
            )}
          </table>
        </Grid>
        <Grid item xs={6}>
          <table width="100%">
            <tr>
              <td>{translate("Transaction Date")}</td>
              <td>
                <PDatePicker
                  value={transactionDate}
                  type="date"
                  error={transactionDateError}
                  onChange={(e) => setTransactiondate(e)}
                ></PDatePicker>
              </td>
            </tr>
            <tr>
              <td>{translate("Amount")}</td>
              <td>
                <PText
                  value={amount}
                  InputProps={{
                    readOnly: true,
                  }}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>{translate("Payee")}</td>
              <td>
                <PText
                  value={payeeName}
                  error={payeeNameError}
                  onChange={(e) => setPayeeName(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>{translate("Description")}</td>
              <td>
                <PText
                  value={description}
                  error={descriptionError}
                  onChange={(e) => setDescription(e.target.value)}
                ></PText>
              </td>
            </tr>
          </table>
        </Grid>
        <Grid item xs={12} sm={12}>
          <MUIDataTable
            data={toAccountItemsList}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    return false;
  }

  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"md"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          onDelete={onDelete}
          mode={mode}
          isDataChanged={isDataChanged}
        ></PDialog>
      )}

      <GenericReportViewer
        biRef={biRef}
        showMessage={props.showMessage}
      ></GenericReportViewer>
    </div>
  );
}
